exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info[data-v-111ab27b]{position:fixed;border:1px solid #e6a23c;padding:10px;top:-30px;left:50%;background-color:#fdf6ec;transform:translate(-50%,50px);color:#e6a23c;font-size:14px;font-weight:700;border-radius:4px}.info-enter-active[data-v-111ab27b],.info-leave-active[data-v-111ab27b]{transition:all .3s}.info-enter[data-v-111ab27b],.info-leave-to[data-v-111ab27b]{transform:translate(-50%);opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.2@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-111ab27b","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.0.3@sass-loader/lib/loader.js!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=styles&index=0!./src/lib/info/main.vue
// module id = 23
// module chunks = 0